import { render, staticRenderFns } from "./AccountPreferences.vue?vue&type=template&id=b4f90388&scoped=true&"
import script from "./AccountPreferences.vue?vue&type=script&lang=js&"
export * from "./AccountPreferences.vue?vue&type=script&lang=js&"
import style0 from "./AccountPreferences.vue?vue&type=style&index=0&id=b4f90388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f90388",
  null
  
)

export default component.exports